import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export async function getRouteBuffer(salesOrg: string, deliveryPlant?: string, route?: string, material?: string) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      deliveryPlant,
      route,
      material,
    },
    url: `${BASE_URL}/api/planning/buffer`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function saveRouteBuffer(
  salesOrg: string,
  salesOffice:string,
  deliveryPlant: string,
  route: string,
  material: string,
  onlineBuffer: any,
  offlineBuffer: any
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      salesOffice,
      deliveryPlant,
      route,
      material,
      onlineBuffer,
      offlineBuffer,
    },
    url: `${BASE_URL}/api/planning/buffer/save`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function editRouteBuffer(
  salesOrg: string,
  salesOffice: string,
  deliveryPlant:string,
  route: string,
  material: string,
  onlineBuffer: any,
  offlineBuffer: any
) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      salesOffice,
      deliveryPlant,
      route,
      material,
      onlineBuffer,
      offlineBuffer,
    },
    url: `${BASE_URL}/api/planning/buffer/edit`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}
export async function deleteRouteBuffer(salesOrg: string, salesOffice: string,deliveryPlant:string, route: string, material: string) {
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
    },
    data: {
      salesOffice,
      deliveryPlant,
      route,
      material,
    },
    url: `${BASE_URL}/api/planning/buffer/delete`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}
